var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16669 0.666992C4.02455 0.666992 0.666687 4.02486 0.666687 8.16699C0.666687 12.3091 4.02455 15.667 8.16669 15.667C9.93753 15.667 11.565 15.0533 12.8481 14.0269L15.9108 17.0896C16.2362 17.415 16.7638 17.415 17.0893 17.0896C17.4147 16.7641 17.4147 16.2365 17.0893 15.9111L14.0266 12.8484C15.053 11.5653 15.6667 9.93784 15.6667 8.16699C15.6667 4.02486 12.3088 0.666992 8.16669 0.666992ZM2.33335 8.16699C2.33335 4.94533 4.94503 2.33366 8.16669 2.33366C11.3883 2.33366 14 4.94533 14 8.16699C14 11.3887 11.3883 14.0003 8.16669 14.0003C4.94503 14.0003 2.33335 11.3887 2.33335 8.16699Z",
    fill: "#667185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch);
export default __webpack_public_path__ + "static/media/ic_search.c05de9b6d004cbe60b5ef39d8911285b.svg";
export { ForwardRef as ReactComponent };